'use strict';

import BaseService from './base.service';

class FleetsService extends BaseService {
  /* @ngInject */
  constructor(Fleet, SegaUser) {
    super(Fleet, SegaUser);
    Object.assign(this, {
      Fleet
    });
  }
}

export default FleetsService;
